import '../../sass/front/admin-control.sass'

export default class AdminControlExtension {

	constructor(naja) {
		naja.addEventListener('init', this.init.bind(this));
	}

	init() {
		let adminBtn = document.getElementById('fn_admin-control-btn');
		let adminBox = document.getElementById('fn_admin-control-box');

		if (adminBtn && adminBox) {
			document.addEventListener('click', function (e) {

				if (e.target && e.target.id === 'fn_admin-control-btn') {
					e.preventDefault();
					if (adminBox.classList.contains('show')) {
						adminBox.classList.remove('show');
					} else {
						adminBox.classList.add('show');
					}
				}

				if (e.target && e.target.id === 'fn_admin-control-close') {
					e.preventDefault();
					if (adminBox.classList.contains('show')) {
						adminBox.classList.remove('show');
					} else {
						adminBox.classList.add('show');
					}
				}
			});
		}
	}
}